import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ContactInquiryService } from "../../../services/contact-inquiry.service";
import { UtilsService } from "../../../services/utils.service";

@Component({
  selector: "app-contact-inquiry-view",
  templateUrl: "./contact-inquiry-view.component.html",
  styleUrls: ["./contact-inquiry-view.component.scss"],
})
export class ContactInquiryViewComponent implements OnInit {
  inquiry;
  inquiryId;

  constructor(
    private route: ActivatedRoute,
    private graphqlService: ContactInquiryService,
    private utilsService: UtilsService,
  ) {
    route.params.subscribe((params) => {
      if (params["id"]) {
        this.inquiryId = params["id"];
        this.fetchInquiry();
      }
    });
  }

  ngOnInit() {}

  fetchInquiry() {
    this.graphqlService.read(this.inquiryId).subscribe((result) => {
      if (result && result.data) {
        this.inquiry = result.data["contactInquiry"];
        this.utilsService.openSnackBar("Inquiry Data Loaded !!", "");
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/contact-inquiries/contact-inquiry-view/contact-inquiry-view.component.ts